import { render, staticRenderFns } from "./TheModalCierreTratamiento.vue?vue&type=template&id=ea88e402&scoped=true&"
import script from "./TheModalCierreTratamiento.vue?vue&type=script&lang=js&"
export * from "./TheModalCierreTratamiento.vue?vue&type=script&lang=js&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea88e402",
  null
  
)

export default component.exports